import DOMPurify from 'dompurify';

/**
 * Bereinigt HTML vor der Ausgabe via dangerouslySetInnerHTML.
 * Entfernt <script>, Event-Handler-Attribute (onerror, onclick, …) u. Ä.,
 * sodass von Nutzern stammendes Mail-/Template-HTML kein XSS auslösen kann.
 */
export const sanitizeHtml = (html: string | null | undefined): string =>
    DOMPurify.sanitize(html ?? '');
